module.exports = __webpack_public_path__ + "static/media/8604-f-l.ad2e6e5c.png";